import { c as _c } from "react/compiler-runtime";
import RealEstateDetailMobile from "./RealEstateDetailMobile/RealEstateDetailMobile";
interface Props {
  realEstateSlug: string;
  inDialog?: boolean;
}

// Demand listings render through the same mobile detail as supply — only the
// images hero (→ avatar/bio) and the location (→ area polygon) differ, handled
// inside RealEstateDetailMobile.
export function RealEstateDetailMobileWrapper(t0) {
  const $ = _c(3);
  const {
    realEstateSlug,
    inDialog
  } = t0;
  let t1;
  if ($[0] !== inDialog || $[1] !== realEstateSlug) {
    t1 = <RealEstateDetailMobile realEstateSlug={realEstateSlug} inDialog={inDialog} data-sentry-element="RealEstateDetailMobile" data-sentry-component="RealEstateDetailMobileWrapper" data-sentry-source-file="RealEstateDetailMobileWrapper.tsx" />;
    $[0] = inDialog;
    $[1] = realEstateSlug;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}